import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import TextLink from 'LuxKit/TextLink'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import styled from 'styled-components'

const Span = styled.div`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverHeroSubtitle() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()

  const triplePointsPill = (
    <Span>
      <LoyaltyTierPill kind="primary" tier={tier}>
        {intl.formatMessage({
          id: '3irLpPPES2',
          defaultMessage: 'Triple Points',
          description: 'Loyalty tier pill label for triple points promotion',
        })}
      </LoyaltyTierPill>
    </Span>
  )

  const viewAllOffersText = intl.formatMessage({
    id: 'xc1/PQ86W5',
    defaultMessage: 'View all offers',
    description: 'Link text to view all triple points offers',
  })

  return <div>
    <FormattedMessage
      id="E06eFof9S8"
      defaultMessage="Look for {pill} on select packages! Hurry, limited time only."
      description="Hero subtitle text directing users to look for triple points pill on select packages"
      values={{ pill: triplePointsPill }}
    />{' '}
    <TextLink wrap="no-wrap" to="/triple-points">{viewAllOffersText}</TextLink>
  </div>
}

export default TriplePointTakeoverHeroSubtitle
